import { render, staticRenderFns } from "./contact-details-personalised.vue?vue&type=template&id=a36fdc52&scoped=true"
import script from "./contact-details-personalised.vue?vue&type=script&lang=js"
export * from "./contact-details-personalised.vue?vue&type=script&lang=js"
import style0 from "./contact-details-personalised.vue?vue&type=style&index=0&id=a36fdc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36fdc52",
  null
  
)

export default component.exports